<template>
  <div class="vx-col w-full">
    <vx-card class="digitelex-popup-content">
      <form>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <vs-input
              v-validate="'required|alpha_num|min:2'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Name"
              label-placeholder="Name"
              name="collectionAgentName"
              v-model="frm.collectionAgentName"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('collectionAgentName')"
              ><span class="digitelex-form-error-message">{{
                errors.first("collectionAgentName")
              }}</span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('collectionAgentName')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <vs-input
              v-validate="'alpha_num|max:2'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Short Name"
              label-placeholder="Short Name"
              name="collectionAgentShortName"
              v-model="frm.collectionAgentShortName"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('collectionAgentShortName')"
              ><span class="digitelex-form-error-message">{{
                errors.first("collectionAgentShortName")
              }}</span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('collectionAgentShortName')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="flex flex-wrap justify-end">
          <vs-button
            :disabled="!validateForm"
            @click="saveCollectionAgent"
            class="ml-auto"
            >Save Changes</vs-button
          >
          <vs-button class="ml-4" type="border" color="warning"
            >Cancel</vs-button
          >
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
const dict = {
  custom: {
    clientName: {
      required: "Please enter your first name",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};

Validator.localize("en", dict);

export default {
  props: {
    frmData: {},
  },
  methods: {
    saveCollectionAgent() {
      if (this.frm.collectionAgentId) {
        //Update
        // alert("Updated");
        this.$http
          .put("portage/collectionAgent", this.frm)
          .then((response) => {
            this.$emit("submitResponse", response);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.frm.collectionAgentId = 0;
        this.frm.isActive = true;
        this.$http
          .post("portage/collectionAgent", this.frm)
          .then((response) => {
            this.$emit("submitResponse", response);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  data() {
    return {
      frm: {
        collectionAgentName: null,
        collectionAgentId: 0,
        collectionAgentShortName: null,
        isActive: null,
      },
    };
  },
  watch: {
    frmData: {
      handler(after) {
        this.frm = after;
      },
      immediate: true,
    },
  },

  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.frm.collectionAgentName != "" &&
        this.frm.collectionAgentName != null
      );
    },
  },
  beforeMount() {
    console.log(this.frmData);
  },
};
</script>
